module.exports = __webpack_public_path__ + "static/media/logoSer.ac521140.png";